module.exports = __webpack_public_path__ + "img/product_linkScreen.918108df.png";